/* SAMPLE COLLECTORS */
// get qualitativetypes
export const GET_QUALITATIVETYPE_LIST = "GET_QUALITATIVETYPE_LIST";
export const GET_QUALITATIVETYPE_LIST_SUCCESS ="GET_QUALITATIVETYPE_LIST_SUCCESS";
export const GET_QUALITATIVETYPE_LIST_FAIL = "GET_QUALITATIVETYPE_LIST_FAIL";
// Add qualitativetypes
export const ADD_NEW_QUALITATIVETYPE = "ADD_NEW_QUALITATIVETYPE";
export const ADD_NEW_QUALITATIVETYPE_SUCCESS = "ADD_NEW_QUALITATIVETYPE_SUCCESS";
export const ADD_NEW_QUALITATIVETYPE_FAIL = "ADD_NEW_QUALITATIVETYPE_FAIL";
//Update QualitativeType
export const UPDATE_QUALITATIVETYPE = "UPDATE_QUALITATIVETYPE";
export const UPDATE_QUALITATIVETYPE_SUCCESS = "UPDATE_QUALITATIVETYPE_SUCCESS";
export const UPDATE_QUALITATIVETYPE_FAIL = "UPDATE_QUALITATIVETYPE_FAIL";


/////reagents added by analytes

export const GET_AnalyteQualitativeUnits_LIST = "GET_AnalyteQualitativeUnits_LIST_LIST";
export const GET_AnalyteQualitativeUnits_LIST_SUCCESS ="GET_AnalyteQualitativeUnits_LIST_SUCCESS";
export const GET_AnalyteQualitativeUnits_LIST_FAIL = "GET_AnalyteQualitativeUnits_LIST_FAIL";
// Add REAGENT
export const ADD_NEW_AnalyteQualitativeUnits = "ADD_NEW_AnalyteQualitativeUnits";
export const ADD_NEW_AnalyteQualitativeUnits_SUCCESS = "ADD_NEW_AnalyteQualitativeUnits_SUCCESS";
export const ADD_NEW_AnalyteQualitativeUnits_FAIL = "ADD_NEW_AnalyteQualitativeUnits_FAIL";
//Update REAGENT
export const UPDATE_AnalyteQualitativeUnits = "UPDATE_AnalyteQualitativeUnits";
export const UPDATE_AnalyteQualitativeUnits_SUCCESS = "UPDATE_AnalyteQualitativeUnits_SUCCESS";
export const UPDATE_AnalyteQualitativeUnits_FAIL = "UPDATE_AnalyteQualitativeUnits_FAIL";

